import React from 'react'
import { ServerContextContext } from './ServerContextContext.mjs'
export var useServerContext = function useServerContext() {
  return React.useContext(ServerContextContext)
}
